
import TFQModel from "./TFQModel"
import TFAnsModel from "./TFAnsModel"
import TFReadTextModel from "../../activity/model/TFReadTextModel"
import Activity from "../../activity/model/Activity";
import AnsContainer from "./AnsContainer";


class TFACtivityModel extends Activity {
    constructor() {

        super()
        this.activityType = this.TF_ACTIVITY_TYPE
        this.tfQ = new TFQModel("");
        this.ansContainer = new AnsContainer()
        this.degree = 0;
        this.totalDegree = 1;
    }





    getAnsweredTrue = () => {
        let { tfAnsArr } = this.ansContainer
        for (let i = 0; i < tfAnsArr.length; i++) {
            if ((tfAnsArr[i].isSelected && !tfAnsArr[i].isRight)
                || (tfAnsArr[i].isRight && !tfAnsArr[i].isSelected)) {

                this.answeredTrue = false;
                break;
            }
        }

        this.isSkipped = true;
        for (let i = 0; i < tfAnsArr.length; i++) {
            if (tfAnsArr[i].isSelected) {
                this.isSkipped = false;
            }
        }


    }


    resetActivity = () => {

        this.answeredTrue = true
        for (let i = 0; i < this.ansContainer.tfAnsArr.length; i++) {
            this.ansContainer.tfAnsArr[i].isSelected = false

        }



    }




    initFromJson = (obj) => {

        this.initPublicItemsFromJson(obj)
        this.tfQ.initFromJson(obj.tfQ)
        this.ansContainer.initFromJson(obj.ansContainer)
        console.log("ansContainer")
        console.log(obj.ansContainer)

    }


    initFromJsonTest4You = (obj) => {

        this.initPublicItemsFromJsonTest4You(obj)
        this.tfQ.initFromJsonTest4You(obj.tfQ)
        this.ansContainer.initFromJsonTest4You(obj.ansContainer)
    }

    initSharedItems = (activityArr) => {
        this.initPublicSharedItem(activityArr);
    }


    getAsJson = () => {

        let jsCode = this.getPublicItemsAsJson();

        jsCode.tfQ = this.tfQ.getAsJson()
        jsCode.ansContainer = this.ansContainer.getAsJson()


        return jsCode

    }



    getReportAsJson = () => {
        let jsCode = {}
        jsCode.activityId = this.activityId
        jsCode.ansContainer = this.ansContainer.getReportAsJson()
        jsCode.answeredTrue = this.answeredTrue
        jsCode.activityType = this.activityType
        jsCode.isSkipped = this.isSkipped
        return jsCode
    }

    // initReportFromJson = (obj) => {
    //     this.activityId=obj.activityId
    //     this.ansContainer.initReportFromJson(obj.ansContainer)
    //     this.answeredTrue=obj.answeredTrue
    // }


    initReportFromJson = (userAns) => {
        // this.ansContainer = new AnsContainer()
        this.ansContainer.initReportFromJson(userAns.ansContainer)
        this.answeredTrue = userAns.answeredTrue
        this.isSkipped = userAns.isSkipped
    }


    hasSelectedAns = () => {
        for (let i = 0; i < this.tfAnsArr.length; i++)
            if (this.tfAnsArr[i].isSelected)
                return true

        return false;
    }
}

export default TFACtivityModel